import { httpRequest } from "../../http";
import type { AggregateVersion } from "@models/aggregateVersion.model";
import type { AggregateActivityEntry } from "@components/versions/AggregateVersionsDrawer";

export interface DefinitionFileHistory {
  versions: AggregateVersion[];
  activity: AggregateActivityEntry[];
}

/**
 * Every file's history for one ingest definition, on one timeline. One request rather than two:
 * the drawer shows Changes and Activity together, and fetching them apart would re-render every
 * file's diffs twice.
 */
export class CommandGetDefinitionFileHistory {
  async run(definitionId: number): Promise<DefinitionFileHistory> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/file-history/`;
    return httpRequest<DefinitionFileHistory>(url, { method: "GET" });
  }
}
